import { render, staticRenderFns } from "./PagesPreview.vue?vue&type=template&id=6e5775c1&scoped=true&lang=html"
import script from "./PagesPreview.vue?vue&type=script&lang=js"
export * from "./PagesPreview.vue?vue&type=script&lang=js"
import style0 from "./PagesPreview.vue?vue&type=style&index=0&id=6e5775c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5775c1",
  null
  
)

export default component.exports